import { useTranslation } from "react-i18next";

import { DropdownButton, DropdownContent, DropdownLink, Dropdown } from "@aviary";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  slug?: string;
}

const CountrySelect = ({ slug }: Props) => {
  const { isCanada } = useSharedGlobalConfig();
  const { t } = useTranslation();

  const USLink = slug ? authRoutes.usApp + slug : authRoutes.usApp;
  const CALink = slug ? authRoutes.caApp + slug : authRoutes.caApp;

  return (
    <Dropdown>
      <DropdownButton isText aria-label={isCanada ? t(l.common.CALogin) : t(l.common.USLogin)}>
        {isCanada ? <>🇨🇦 CA</> : <>🇺🇸 US</>}
      </DropdownButton>
      <DropdownContent>
        <DropdownLink aria-label={t(l.common.GoToUS)} href={USLink}>
          🇺🇸 US
        </DropdownLink>
        <DropdownLink aria-label={t(l.common.GoToCA)} href={CALink}>
          🇨🇦 CA
        </DropdownLink>
      </DropdownContent>
    </Dropdown>
  );
};

export { CountrySelect };
